import PatientDashboard from "@features/clinic-patients/pages/dashboard";
import { ProtectedRoute } from "@shared/ui";
import { ROOTS } from "@app/config/constants";
import { Route } from "react-router-dom";

export default function getPatientRoutes() {
  return (
    <Route
      path={`${ROOTS.PATIENT}`}
      element={
        <ProtectedRoute>
          <PatientDashboard />
        </ProtectedRoute>
      }
    />
  );
}
